// Contact locations tabbed navigation.
// Switches the visible location panel on tab click. One panel shown at a time.

document.addEventListener("DOMContentLoaded", function () {
	const blocks = document.querySelectorAll(".contact-locations");

	blocks.forEach(function (block) {
		const tabs = Array.prototype.slice.call(
			block.querySelectorAll(".contact-locations__tab")
		);
		const panels = Array.prototype.slice.call(
			block.querySelectorAll(".contact-locations__panel")
		);
		const scroller = block.querySelector(".contact-locations__nav ul");

		if (tabs.length < 2) {
			return;
		}

		// Below 1440px, scroll the tab bar so the clicked tab is centred —
		// except the first (stays flush left) and last (stays flush right).
		function centerTab(index) {
			if (!scroller || window.innerWidth > 1440) {
				return;
			}

			let target;
			if (index === 0) {
				target = 0;
			} else if (index === tabs.length - 1) {
				target = scroller.scrollWidth - scroller.clientWidth;
			} else {
				const tab = tabs[index];
				target =
					tab.offsetLeft - (scroller.clientWidth - tab.offsetWidth) / 2;
			}

			scroller.scrollTo({ left: target, behavior: "smooth" });
		}

		function activate(index) {
			tabs.forEach(function (tab, i) {
				const selected = i === index;
				tab.classList.toggle("is-active", selected);
				tab.setAttribute("aria-selected", selected ? "true" : "false");
				tab.setAttribute("tabindex", selected ? "0" : "-1");
			});

			panels.forEach(function (panel, i) {
				const selected = i === index;
				panel.classList.toggle("is-active", selected);
				if (selected) {
					panel.removeAttribute("hidden");
				} else {
					panel.setAttribute("hidden", "");
				}
			});

			centerTab(index);
		}

		tabs.forEach(function (tab, index) {
			tab.addEventListener("click", function () {
				activate(index);
			});

			// Left/right arrow keyboard navigation between tabs.
			tab.addEventListener("keydown", function (e) {
				let next = null;
				if (e.key === "ArrowRight" || e.key === "ArrowDown") {
					next = (index + 1) % tabs.length;
				} else if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
					next = (index - 1 + tabs.length) % tabs.length;
				}

				if (next !== null) {
					e.preventDefault();
					activate(next);
					tabs[next].focus();
				}
			});
		});
	});
});
